import { render, staticRenderFns } from "./about-page.vue?vue&type=template&id=3c4bf331&scoped=true&"
import script from "./about-page.vue?vue&type=script&lang=js&"
export * from "./about-page.vue?vue&type=script&lang=js&"
import style0 from "./about-page.vue?vue&type=style&index=0&id=3c4bf331&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bf331",
  null
  
)

export default component.exports